/**
 * Repository documents catalogue.
 *
 * --- HOW TO ADD A NEW ISSUE ----------------------------------------------
 *  1. Drop the PDF into /app/frontend/public/repository/<slug>.pdf
 *     (e.g. /app/frontend/public/repository/dos.pdf)
 *  2. Add a new entry to the DOCUMENTS array below, keeping the order you
 *     want them to appear in the vault grid:
 *
 *      {
 *        id: "dos",                              // unique slug, used in URL
 *        index: "02",                            // brutalist 2-digit label
 *        title: "DOS",                           // big caps title
 *        subtitle: "Second issue",               // small line under
 *        filename: "Pandurata-Repository-Dos.pdf",
 *        src: "/repository/dos.pdf",             // same-origin so PDF.js loads it
 *      }
 *
 *  3. That's it. The Repository index will show the new box automatically
 *     and the URL /repository/<slug> will render the new document in the
 *     same fullscreen reader.
 *
 *  No backend changes are needed. The /api/repository-download endpoint
 *  already accepts any {document_id, document_title} and emails the studio.
 */

const DOCUMENTS = [
  {
    id: "uno",
    index: "01",
    title: "UNO",
    subtitle: "Premiere — first issue",
    filename: "Pandurata-Repository-Uno.pdf",
    src: "/repository/uno.pdf",
  },
  {
    id: "dos",
    index: "02",
    title: "DOS",
    subtitle: "Second issue",
    filename: "Pandurata-Repository-Dos.pdf",
    src: "/repository/dos.pdf",
  },
];

export default DOCUMENTS;

export const getDocumentById = (id) =>
  DOCUMENTS.find((doc) => doc.id === id) || null;
